/**
 * Radar chart showing system-wide subscale averages.
 */

import {
  RadarChart,
  Radar,
  PolarGrid,
  PolarAngleAxis,
  PolarRadiusAxis,
  ResponsiveContainer,
  Tooltip,
} from 'recharts';
import type { RadarPoint } from '@/lib/dashboard/aggregations';

export function SystemRadarChart({ data }: { data: RadarPoint[] }) {
  return (
    <div className="rounded-xl border bg-card p-5 shadow-sm">
      <h3 className="mb-4 text-sm font-semibold text-muted-foreground uppercase tracking-wide">
        Subscale Averages
      </h3>
      <ResponsiveContainer width="100%" height={300}>
        <RadarChart data={data} cx="50%" cy="50%" outerRadius="75%">
          <PolarGrid strokeDasharray="3 3" />
          <PolarAngleAxis dataKey="subscale" tick={{ fontSize: 12, fill: '#64748b' }} />
          <PolarRadiusAxis domain={[0, 7]} tick={{ fontSize: 10 }} tickCount={8} />
          <Tooltip
            formatter={(v) => {
              const num = typeof v === 'number' ? v : Number(v);
              return [`${Number.isFinite(num) ? num.toFixed(2) : v}`, 'Average'];
            }}
          />
          <Radar
            dataKey="average"
            stroke="#1f2b5b"
            fill="#1f2b5b"
            fillOpacity={0.2}
            strokeWidth={2}
          />
        </RadarChart>
      </ResponsiveContainer>
    </div>
  );
}
